import { Promotion } from 'types/utils';

export const ACCESSORIES_ELEMENT_BLOCK_NAME = 'landingSpaceoKub';

export const PROMOTION_LIST: Promotion[] = [
  {
    name: 'SpaceoKub_bottom',
    creative: 'Корзины и аксессуары',
    position: '1',
  },
  {
    name: 'SpaceoKub_bottom',
    creative: 'Короба для хранения',
    position: '2',
  },
  {
    name: 'SpaceoKub_bottom',
    creative: 'Полки, фасады и выдвижные ящики',
    position: '3',
  },
];
